<template>
  <div class="CardDetails">
    <div class="CardDetails-background">
      <div class="payment-AppTitle">
        <img src="../../public/obraoag/paymentReturn.png" alt="" @click="BackLevel()">
        卡明细
      </div>
      <div class="CardDetails-content">
        <div class="CardDetails-DefaCard-title">
          <p v-if="desate == '0'">{{this.decrme}}<span class="CardDetails-DefaCard-title-state">未激活</span></p>
          <p v-else-if="desate == '1'">{{this.decrme}}<span class="CardDetails-DefaCard-title-state">正常</span></p>
          <p v-else-if="desate == '2'">{{this.decrme}}<span class="CardDetails-DefaCard-title-state">挂失</span></p>
          <p>{{this.decter}}</p>
        </div>
        <div class="CardDetails-DefaCard-title">
          <p v-if="this.decrme != '欧宝卡'">积分 {{Math.floor(this.deinal * 100) / 100}}</p>
          <p>余额 {{Math.floor(this.debace * 100) / 100}}</p>
        </div>
      </div>
      <div class="CardDetails-category">
        <div class="CardDetails-category-content" @click="cadebume(1)">
          <img src="../../public/obraoag/Cardailsgs.png" alt="">
          <p>挂失</p>
        </div>
        <div class="CardDetails-category-content" @click="cadebume(2)">
          <img src="../../public/obraoag/Cardailsjg.png" alt="">
          <p>解挂</p>
        </div>
        <div class="CardDetails-category-content" @click="cadebume(5)">
          <img src="../../public/obraoag/Cardailshk.png" alt="">
          <p>换卡</p>
        </div>
        <div class="CardDetails-category-content" @click="cadebume(4)">
          <img src="../../public/obraoag/Cardailsxk.png" alt="">
          <p>销卡</p>
        </div>
      </div>
    </div>
    <!-- 失败提示 -->
    <div id="warnToast" :style="'display:' + cadefail">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-warn weui-icon_toast"></i>
        <p class="weui-toast__content">{{cadetips}}</p>
      </div>
    </div>
    <!-- 成功提示 -->
    <div id="toast" :style="'display:' + cadesucs">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-success-no-circle weui-icon_toast"></i>
        <p class="weui-toast__content">{{cadetips}}</p>
      </div>
    </div>
    <!-- 选择框 -->
    <div id="dialogs">
      <div class="js_dialog" id="iosDialog1" style="display: none;">
        <div class="weui-mask" @click="cademask()"></div>
        <div id="js_dialog_1" class="weui-half-screen-dialog">
          <div class="weui-half-screen-dialog__hd">
            <div class="weui-half-screen-dialog__hd__side">
              <button class="weui-icon-btn" @click="cademask()">关闭<i class="weui-icon-close-thin"></i></button>
            </div>
            <div class="weui-half-screen-dialog__hd__main">
              <strong class="weui-half-screen-dialog__title">请输入支付密码</strong>
            </div>
          </div>
          <div class="weui-half-screen-dialog__bd">
            <div class="CardDetails-paword">
              <el-input type="password" v-model="cadepsod" placeholder="请输入密码" clearable show-password @input="cadepard()"></el-input>
              <button @click="cadeoptn()">确认</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <TextTips></TextTips>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      decrme: '',
      decter: '',
      debace: '',
      deinal: '',
      desate: '',
      cadepsod: '',
      loginID: '',
      decard: '',
      cadefail: 'none',
      cadetips: '',
      cadesucs: 'none'
    }
  },
  created () {
    // 从缓存里获取token
    this.loginID = localStorage.getItem("usertoken");
    // 接收卡包里的卡信息
    this.decrme = this.$route.query.cacrme;
    this.decter = this.$route.query.cacter;
    this.debace = this.$route.query.cabace;
    this.deinal = this.$route.query.cainal;
    this.desate = this.$route.query.casate;
  },
  mounted () {

  },
  methods: {
    // 点击出现输入支付密码弹框
    cadebume(decare){
      this.decard = decare
      if(this.decard == '4'){
        if(this.deinal == '0' && this.debace == '0'){
          this.$('#js_dialog_1').addClass('weui-half-screen-dialog_show');
          this.$('#iosDialog1').fadeIn(200);
        }else{
          this.cadetips = '销卡失败,请将卡内余额和积分转至同种卡';
          this.cadefail = 'block';
          const _this = this;
          setTimeout(function(){
            _this.cadefail = 'none';
          },1200)
        }
      }else{
        this.$('#js_dialog_1').addClass('weui-half-screen-dialog_show');
        this.$('#iosDialog1').fadeIn(200);
      }
    },
    // 点击遮罩层或者关闭按钮时输入支付密码弹框消失
    cademask(){
      this.$('#js_dialog_1').removeClass('weui-half-screen-dialog_show');
      this.$('#iosDialog1').fadeOut(200);
      this.cadepsod = ''
    },
    // 获取用户输入的密码
    cadepard(){
      // console.log(this.cadepsod)
    },
    // 点击确认提交对卡进行的操作
    cadeoptn(){
      if(this.cadepsod == ''){
        this.cadetips = '支付密码不能为空';
        this.cadefail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.cadefail = 'none';
        },1200)
      }else{
        if(this.decard == '5'){
          this.$router.push({name: 'BindCard',query: {castus: '5',deoler: this.decter,deolrd: this.cadepsod}});
        }else{
          this.$axios.post('app/appParentCard',this.$qs.stringify({
            uptype: this.decard,
            token: this.loginID,
            cnumber: this.decter,
            cpassword: this.cadepsod
          }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
          .then(res => {
            if(res.data.code == '200'){
              this.cadetips = res.data.msg;
              this.cadesucs = 'block';
              const _this = this;
              setTimeout(function(){
                _this.cadesucs = 'none';
              },1200)
            }else{
              this.cadetips = res.data.msg;
              this.cadefail = 'block';
              const _this = this;
              setTimeout(function(){
                _this.cadefail = 'none';
              },1200)
            }
          })
          .catch(() => {
            console.log('获取失败');
          });
        }
      }
      this.$('#js_dialog_1').removeClass('weui-half-screen-dialog_show');
      this.$('#iosDialog1').fadeOut(200);
      this.cadepsod = ''
    },
    // 返回上一层
    BackLevel(){
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
  @import "obraocs/CardDetails.css";
</style>